import { useContext, useEffect, useRef, useState } from "react";
import * as THREE from 'three'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import * as OBC from "openbim-components";
import CameraControls from "camera-controls";
import axios from 'axios';
import GuideBox from "./ModalGuide";
import walking from '../assets/walking.png';
import fullSize from '../assets/full-size.png';
import reDo from '../assets/undo.png';
import noFullScreen from '../assets/fullscreen.png'
import { AppStateContext } from "../Context/contextState";
import rotation from '../assets/rotation.png'

export default function CanvasPublish(props) {

    const [downloadProgress, setDownloadProgress] = useState(1);
    const [backgroundBtn, setBackgroundBtn] = useState(true)

    const {
        setLoading,
    } = useContext(AppStateContext);

    const canvasRef = useRef(null)
    const [filePath, setFilePath] = useState();
    const firstload = useRef(true)
    const fileURL = useRef()
    let components;
    let fragmentIfcLoader;
    let scene1;
    const componentsRef = useRef(null)
    let propsProcessor, propsManager, shadows, camera, controls;
    let fragments;

    async function loadIfcAsFragments() {

        console.log('loadIfcAsFragments')
        
        await axios({
            // url: 'https://3dbuilding.parisashahbazi.com/uploads/1TA12.ifc', //your url
            url: `${fileURL.current}`, //your url
            method: 'GET',
            responseType: 'blob', // important
            onDownloadProgress: (progressEvent) => {
                const percentage = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                setDownloadProgress(percentage - 1);
                setLoading(false);
            },
        }).then(async (response) => {
            // const href = URL.createObjectURL(response.data);
            try {
                setLoading(true)
                console.log('response.data>>', response.data)
                const buffer = await response.data.arrayBuffer();
                const data = new Uint8Array(buffer);
                console.log('data local>>', data)

                const model = await fragmentIfcLoader.load(data);
                console.log('model>', model)
                model.scale.set(1, 1, 1); // اضافه کردن این خط

                // محاسبه محدوده مدل و تنظیم خودکار دوربین
            const bbox = new THREE.Box3().setFromObject(model);
            const center = bbox.getCenter(new THREE.Vector3());
            const size = bbox.getSize(new THREE.Vector3());

            camera.controls.fitToBox(bbox, true);
                scene1.add(model);
                shadows.renderShadow([model], "example");
                components.meshes.add(model);
                components.scene.setup();
                setDownloadProgress(0);
                propsProcessor.process(model);
            } catch {
                props.ToastsShow(true);
                props.ToastsShowBack(false);
                props.ToastsText("لود مدل با خطا مواجه شد");
            } finally {
                setLoading(false);
                setTimeout(() => {
                    props.ToastsShow(false);
                }, 6000);
            }


            // const properties = model.getLocalProperties();
            // const elements = model._properties;
            // console.log('***----->>', propsProcessor.getProperties(model, 0))
            // propsProcessor.renderProperties(model, 3136)


        });



    }

    async function init() {
        setLoading(false);
        components = new OBC.Components();
        componentsRef.current = components
        console.log('CameraControls>>', CameraControls)

        components.scene = new OBC.SimpleScene(components);
        // components.renderer = new OBC.SimpleRenderer(components, canvasRef.current);
        components.renderer = new OBC.PostproductionRenderer(components, canvasRef.current)

        const materialManager = new OBC.MaterialManager(components);
        const backgroundColor = new THREE.Color("#ffffff");
        materialManager.setBackgroundColor(backgroundColor);

        camera = new OBC.OrthoPerspectiveCamera(components);
      
        controls = camera.controls
        controls.mouseButtons.wheel = CameraControls.ACTION.DOLLY
        //  controls.dollyToCursor=true;
        camera.controls.setLookAt(10, 10, 10, 0, 0, 0);
        camera.near = 0.1;
        camera.far = 1000;
        controls.infinityDolly = false
        controls.minDistance = 1; //dolly
        controls.maxDistance = 300; //dolly
        controls.mouseButtons.middle = CameraControls.ACTION.TRUCK;
        controls.touches.one = CameraControls.ACTION.TOUCH_ROTATE;
        controls.touches.two = CameraControls.ACTION.TOUCH_DOLLY;
        controls.mouseButtons.left = CameraControls.ACTION.ROTATE;
        controls.truckSpeed = 5;
        controls.dollySpeed = 6
        controls.infinityDolly = false;




        // camera.controls.setLookAt(5, 5, 5, 0, 0, 0);
        // controls.minDistance = 1;
        // controls.maxDistance = 4200;
        // const position = new THREE.Vector3();
        // controls.getPosition(position);
        // const distance = position.length();
        // controls.distance = distance;
        // controls.truckSpeed = 5;
        // controls.dollySpeed = 5
        // const { rotation } = camera.get();
        // const direction = new THREE.Vector3(0, 0, -1).applyEuler(rotation);
        // const target = position.addScaledVector(direction, distance);
        // controls.moveTo(target.x, target.y, target.z);

        // controls.mouseButtons.middle = CameraControls.ACTION.TRUCK;
        // controls.touches.one = CameraControls.ACTION.TOUCH_TRUCK;
        // controls.touches.two = CameraControls.ACTION.TOUCH_ZOOM;
        // controls.mouseButtons.left = CameraControls.ACTION.ROTATE;


        // controls.azimuthRotateSpeed = active ? 0 : this.defaultAzimuthSpeed;
        // controls.polarRotateSpeed =
        // camera.controls.infinityDolly = true;
        // camera.controls.minDistance = 3;
        // camera.controls.maxDistance=50;
        // camera.controls.maxZoom=15;
        // camera.controls.minZoom=5;

        components.camera = camera;
        console.log('components.camera', components.camera)
        componentsRef.current = components
        components.init();
        shadows = new OBC.ShadowDropper(components);
        shadows.shadowExtraScaleFactor = 55;
        shadows.darkness = 5;
       
        let keys = {
            w: false,
            d: false,
            a: false,
            s: false
        };
        function onKeyDown(event) {

            if (event.key === 'w') {
                keys.w = true;
            }
            if (event.key === 'd') {
                keys.d = true;
            }
            if (event.key === 'a') {
                keys.a = true;
            }
            if (event.key === 's') {
                keys.s = true;
            }

            if (keys.w && keys.d) {
                camera.controls.forward(0.5, true)
                camera.controls.truck(0.5, 0, true)
            }
            if (keys.w && keys.a) {
                camera.controls.forward(0.5, true)
                camera.controls.truck(-0.5, 0, true)
            }
            if (keys.s && keys.a) {
                camera.controls.forward(-0.5, true)
                camera.controls.truck(-0.5, 0, true)
            }
            if (keys.s && keys.d) {
                camera.controls.forward(-0.5, true)
                camera.controls.truck(0.5, 0, true)
            }

            switch (event.keyCode) {
                case 37:// left
                    camera.controls.rotate(+0.1, 0, true)
                    break
                case 65:
                    camera.controls.truck(-0.25, 0, true)
                    break;
                case 38:
                case 87:
                    if (event.shiftKey) {
                        console.log('shift up')
                        camera.controls.forward(1.5, true)
                        break;

                    }
                    console.log('up')
                    camera.controls.forward(0.25, true)
                    break;
                case 39:
                    camera.controls.rotate(-0.1, 0, true)
                    break
                case 68:
                    console.log('right')
                    camera.controls.truck(0.25, 0, true)
                    break;
                case 40:
                case 83:
                    if (event.shiftKey) {
                        console.log('shift down')
                        camera.controls.forward(-1.5, true)
                        break;

                    }
                    console.log('down')
                    camera.controls.forward(-0.25, true)
                    break;
                case 81:
                    camera.controls.truck(0, -0.25, true)
                    console.log('q top')
                    break;
                case 69:
                    camera.controls.truck(0, +0.25, true)
                    console.log('e low')
                    break;

                default:
                    break;
            }
        }
        document.addEventListener('keydown', onKeyDown, false);
        document.addEventListener('keyup', function (event) {
            // Update the state of the key being released
            if (event.key === 'w') {
                keys.w = false;
            }
            if (event.key === 'd') {
                keys.d = false;
            }
            if (event.key === 's') {
                keys.s = false;
            }
            if (event.key === 'a') {
                keys.a = false;
            }
        });


        // components.camera = new OBC.SimpleCamera(components);
        components.raycaster = new OBC.SimpleRaycaster(components);
        components.init();
        scene1 = components.scene.get();

        const directionalLight = new THREE.DirectionalLight();
        directionalLight.position.set(5, 10, 3);
        directionalLight.intensity = 1;
        scene1.add(directionalLight);

        const ambientLight = new THREE.AmbientLight();
        ambientLight.intensity = 1;
        scene1.add(ambientLight);
        
        fragments = new OBC.FragmentManager(components);
        fragmentIfcLoader = new OBC.FragmentIfcLoader(components);
        await fragmentIfcLoader.setup()
        propsProcessor = new OBC.IfcPropertiesProcessor(components);
        propsManager = new OBC.IfcPropertiesManager(components);
        propsProcessor.propertiesManager = propsManager;

        const propsFinder = new OBC.IfcPropertiesFinder(components);
        //new
        components.renderer.postproduction.enabled = true;
        components.renderer.postproduction.customEffects.outlineEnabled = true;
        components.renderer.get().depthBuffer = true;
        components.renderer.get().depthFunc = THREE.LessEqualDepth;
        components.renderer.get().logarithmicDepthBuffer = true; // برای مدل‌های بزرگ
      
        const highlighter = new OBC.FragmentHighlighter(components, fragments);
        highlighter.setup();
        highlighter.outlinesEnabled = true;
        highlighter.updateHighlight();


        fragmentIfcLoader.onIfcLoaded.add(async () => {
            const highlighterEvents = highlighter.events;

            highlighterEvents['select'].onClear.add(() => {
                console.log('onClear');
            });

            highlighterEvents['select'].onHighlight.add(
                (selection) => {
                    console.log('onHighlight');
                    const fragmentID = Object.keys(selection)[0];
                    const expressID = Number([...selection[fragmentID]][0]);
                    let model;
                    //             for (const [_key, value] of group.keyFragments) {

                    for (const group of fragments.groups) {
                        for (const [_key, value] of group.keyFragments) {
                            if (value === fragmentID) {
                                model = group;
                                console.log('model onHighlight', model);

                                break;
                            }
                        }
                    }

                    if (model) {
                        console.log('model>>', model.width)
                        propsProcessor.renderProperties(model, expressID);
                    }
                }
            );

            await highlighter.updateHighlight();
        });



        const mainToolbar = new OBC.Toolbar(components);
        components.ui.addToolbar(mainToolbar);
        mainToolbar.addChild(propsProcessor.uiElement.get("main"));

    }




    function onWindowResize() {
        // camera.current.aspect = canvasRef.current.offsetWidth / canvasRef.current.offsetHeight;
        // camera.current.updateProjectionMatrix();
        // renderer.current.setSize(canvasRef.current.offsetWidth, canvasRef.current.offsetHeight);
        // tick()
    }






    // useEffect(() => {
    //     if (firstload.current === true) {
    //         init().then(() => {
    //             loadModel().then(() => {

    //             })
    //         });
    //         firstload.current = false
    //     }

    //     window.addEventListener('resize', onWindowResize);

    //     return () => {
    //         window.removeEventListener('resize', onWindowResize);
    //     };
    // }, []);

    const [isFullScreen, setIsFullScreen] = useState(false)

    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch((err) => {
                console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
            setIsFullScreen(true);
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
                setIsFullScreen(false)
            }
        }
    };

    useEffect(() => {

        if (firstload.current === true) {
            console.log("props.fileCode1>>", props.fileCode1);
            init().then(() => {
                
                fetch(`https://3dbuilding.parisashahbazi.com/api/files/file/${props.fileCode1}`, {
                    // fetch(`https://api.ifc.mirzaeei.com/api/files/file/${props.fileCode1}`, {
                    // fetch(`https://api.mirzaeei.com/api/files/file/${props.fileCode1}`, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then(async (data) => {
                        console.log('data', data);
                        fileURL.current = data.info.path;
                        loadIfcAsFragments()

                    })
                    .catch((error) => {
                        console.log("Error:");
                    });


            });
            firstload.current = false
        }


    }, [])

    function handeWalk() {
        setBackgroundBtn(false);
        // alert(" برای حرکت می توانید از کلیدهای جهت به همراه موس نیز استفاده کنید.")
        // componentsRef.current.camera.controls.rotateTo(0, Math.PI / 2, 0, true)
        componentsRef.current.camera.setNavigationMode("FirstPerson");
        // camera.setNavigationMode("Orbit");   
    }

    function handleOrbitCamera() {
        setBackgroundBtn(true);
        componentsRef.current.camera.setNavigationMode("Orbit");
    }

    function handleResetCamera() {
        console.log('reset camera')
        componentsRef.current.camera.controls.setLookAt(0, 20, 20, 0, 0, 0);
    }


    return (

        <>

            <div id="project3D" className="Canvas-tag" ref={canvasRef}
                style={{ height: "100%" }}>
                <div className="Bottom-Navbar" dir="ltr">
                    <div className="Bottom-Navbar-container">
                        <button onClick={toggleFullScreen} className="Full-Bottom-Navbar-btn" title="تمام صفحه">
                            {isFullScreen ? (
                                <img src={noFullScreen} alt="" className="Bottom-Navbar-img" />
                            ) : (

                                <img src={fullSize} alt="" className="Bottom-Navbar-img" />
                            )}
                        </button>
                        <button className="Bottom-Navbar-btn"
                            title="راه رفتن در محیط"
                            onClick={handeWalk}
                            style={{ backgroundColor: backgroundBtn ? "rgb(40, 40, 40)" : "#2929fe" }}
                        >
                            <img src={walking} alt="" className="Bottom-Navbar-img" />
                        </button>
                        <button className="Reset-Bottom-Navbar-btn" title="تنظیم مجدد دوربین" onClick={handleResetCamera}>
                            <img src={reDo} alt="" className="Bottom-Navbar-img" title="دوباره" />
                        </button>
                        <button className="Orbit-Bottom-Navbar-btn"
                            title="چرخش"
                            onClick={handleOrbitCamera}
                            style={{ backgroundColor: backgroundBtn ? "#2929fe" : "rgb(40, 40, 40)" }}
                        >
                            <img src={rotation} alt="" className="Bottom-Navbar-img" title="چرخش" />
                        </button>
                        <div className="Bottom-Navbar-container" style={{ borderRadius: "50%" }}>
                            <GuideBox />
                        </div>
                    </div>
                </div>


            </div>

            {downloadProgress > 0 && (
                <div className="progress-bar3" >
                    <div>
                        <div className="outer">
                            <div className="inner">
                                <div id="number">{downloadProgress}</div>
                            </div>
                        </div>
                        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="Gradient">
                                    <stop stopColor="#da22ff" offset="0%" />
                                    <stop stopColor="#9733ee" offset="100%" />
                                </linearGradient>
                            </defs>
                            <circle cx="50" cy="50" r="42" style={{ strokeDasharray: `265 265`, strokeDashoffset: `calc(265 - (265 * ${downloadProgress}) / 100)` }} />
                        </svg>
                    </div>
                </div>
            )}

        </>

    )
}